import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  fromTable: {
    selectResult: {
      data: {} as any,
      formularState: false,
      findShip: false,
    },
    mmsiArray: [],
    groupArray: [],
    ntfRulesArray: [],
  },
  selectedRow: {} as any,
};

export const tableSlice = createSlice({
  name: 'tableSlice',
  initialState,
  reducers: {
    setShipSelect: (state, action: PayloadAction<any>) => {
      state.fromTable.selectResult = action.payload;
    },
    setSelectedMmsi: (state, action: PayloadAction<any>) => {
      state.fromTable.mmsiArray = action.payload;
    },
    setSelectedGroup: (state, action: PayloadAction<any>) => {
      state.fromTable.groupArray = action.payload;
    },
    setSelectedRow: (state, action: PayloadAction<any>) => {
      state.selectedRow = action.payload;
    },
    setSelectedNtfRules: (state, action: PayloadAction<any>) => {
      state.fromTable.ntfRulesArray = action.payload;
    },
  },
});

export const { setShipSelect, setSelectedMmsi, setSelectedGroup, setSelectedRow, setSelectedNtfRules } = tableSlice.actions;
export default tableSlice.reducer;
